/**
 *
 * Validações comuns para os forms do eFis.
 *
 * https://github.com/jquense/yup
 *
 */

export const validCpf = {
  exclusive: false,
  message: "O CPF informado é inválido",
  test: (value) => {
    if (value == null) return false;

    return /[0-9]{11}/.exec(value);
  },
};

export const validTelefone = {
  exclusive: false,
  message: "O telefone informado é inválido (inclua o DDD)",
  test: (value) => {
    if (value == null) return false;

    return /[0-9]{11}/.exec(value);
  },
};
